import React, { Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Language } from '../App';
interface HeroSectionProps {
  language: Language;
}
export function HeroSection({
  language
}: HeroSectionProps) {
  const isPashto = language === 'pashto';
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <main className="relative pt-[72px] md:pt-[80px] overflow-hidden bg-white" data-id="element-140">
      {/* Hero Image */}
      <motion.div initial={{
      opacity: 0,
      scale: 1.05
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1.2,
      ease: 'easeOut'
    }} className="relative w-full overflow-hidden" data-id="element-141">
        <img src="https://cdn.magicpatterns.com/uploads/57ACH2Q3nqbMQVesMQgq1H/hero_new.png" alt={isPashto ? 'د پښتون کلتور' : 'Pashtun culture and heritage'} className="w-full h-auto object-contain" data-id="element-142" />
        {/* Gradient overlay at bottom for smooth transition */}
        <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent" data-id="element-143"></div>
      </motion.div>

      {/* Text Content Below Image */}
      <div className="relative -mt-12 md:-mt-16 z-10 pb-6 px-6" data-id="element-144">
        <div className="max-w-5xl mx-auto w-full text-center" data-id="element-145">
          <AnimatePresence mode="wait" data-id="element-146">
            <motion.div key={language} variants={containerVariants} initial="hidden" animate="visible" exit={{
            opacity: 0,
            y: -20,
            transition: {
              duration: 0.4,
              ease: 'easeIn'
            }
          }} className="flex flex-col items-center" data-id="element-147">
              {/* Brand Name */}
              <motion.h1 variants={itemVariants} className={`mb-3 md:mb-4 text-pasoon-dark ${isPashto ? 'font-pashto text-5xl sm:text-6xl md:text-8xl leading-normal md:leading-[1.4]' : 'font-serif text-5xl sm:text-6xl md:text-7xl font-bold leading-tight'}`} data-id="element-148">
                {isPashto ? <span className="text-pasoon-red" data-id="element-149">پاڅون</span> : <span className="text-pasoon-red" data-id="element-150">Pasoon</span>}
              </motion.h1>

              {/* Subheading */}
              <motion.p variants={itemVariants} className={`max-w-2xl mx-auto text-xl sm:text-2xl md:text-3xl text-pasoon-dark font-bold mb-8 px-4 ${isPashto ? 'font-pashto leading-loose' : 'font-serif uppercase tracking-wide'}`} data-id="element-151">
                {isPashto ? 'د مورنۍ ژبې پښتو لپاره نوې هیله' : 'A New Hope for Mother Language Pashto'}
              </motion.p>

              {/* CTAs */}
              <motion.div variants={itemVariants} className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 w-full sm:w-auto px-4" data-id="element-152">
                <Link to="/current-issue" className={`w-full sm:w-auto min-w-[200px] px-8 py-4 md:py-5 bg-pasoon-red text-white rounded-full font-medium text-lg hover:bg-red-800 transition-all shadow-xl shadow-red-900/20 hover:shadow-red-900/30 hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98] text-center ${isPashto ? 'font-pashto' : 'font-sans'}`} data-id="element-153">
                  {isPashto ? 'وروستی ګڼه ولولئ' : 'Read Latest Issue'}
                </Link>
                <Link to="/subscription" className={`w-full sm:w-auto min-w-[200px] px-8 py-4 md:py-5 bg-white/50 backdrop-blur-sm border-2 border-pasoon-red text-pasoon-red rounded-full font-medium text-lg hover:bg-red-50 transition-all active:scale-[0.98] text-center ${isPashto ? 'font-pashto' : 'font-sans'}`} data-id="element-154">
                  {isPashto ? 'پاڅون سره مرسته وکړئ' : 'Support Pasoon'}
                </Link>
              </motion.div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </main>;
}